import { IconCheck, IconChevronDown } from '@tabler/icons-react'
import { SelectProps as AntSelectProps, Select as AntSelect } from 'antd'
import styled from 'styled-components'

import { baseInputStyles } from './Input'

import { findScrollableParent } from '@/utils/findScrollableParent'

const APPLE_REGEX = /iPhone|iPad|iPod/i

const enableVirtual = () => {
  if (typeof window === 'undefined') return true
  return !APPLE_REGEX.test(window?.navigator?.userAgent) // not apple
}

const BuildPassLookinSelect = styled(AntSelect)<{ $fullWidth?: boolean }>`
  & > .ant-select-selector {
    ${baseInputStyles}

    & .ant-select-selection-placeholder {
      color: ${({ theme }) => theme.colour.secondary._400};
    }

    /* copied for !important reasons */
    border: 1px solid ${({ theme }) => theme.colour.secondary._400} !important;
    border-radius: ${({ theme }) => theme.borderRadius.small} !important;

    color: ${({ theme }) => theme.colour.secondary._900} !important;
  }

  ${({ $fullWidth }) => $fullWidth && 'width: 100% !important;'}
`

export function Select<T, K>({
  children,
  $fullWidth,
  ...selectProps
}: AntSelectProps<T, K> & { $fullWidth?: boolean }) {
  const icons = {
    suffixIcon: <IconChevronDown size={16} />,
    menuItemSelectedIcon: <IconCheck size={16} />,
  }

  return (
    <BuildPassLookinSelect
      virtual={enableVirtual()} // turning this off for iOS devices improves the scrolling experience: https://github.com/ant-design/ant-design/issues/37674
      getPopupContainer={findScrollableParent}
      {...selectProps}
      $fullWidth={$fullWidth}
      {...(!selectProps?.loading && icons)} // adding icon props and passing the loading parameter doesn't work: https://github.com/ant-design/ant-design/issues/42631
    >
      {children}
    </BuildPassLookinSelect>
  )
}

Select.displayName = 'Select'
Select.Option = AntSelect.Option
Select.OptGroup = AntSelect.OptGroup

export type SelectProps = AntSelectProps

export const Option = AntSelect.Option

export const OptGroup = AntSelect.OptGroup
